import { render, staticRenderFns } from "./EquipmentPage.vue?vue&type=template&id=7035c4a1&scoped=true"
import script from "./EquipmentPage.vue?vue&type=script&lang=js"
export * from "./EquipmentPage.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/equipmentPage.scss?vue&type=style&index=0&id=7035c4a1&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7035c4a1",
  null
  
)

export default component.exports